import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { SearchLoader } from '../search';

export const GlobalLoader = () => (
  <>
    {Array.from({ length: 4 }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Box my={2} key={index}>
        <Box display="flex" flexDirection="column" gridGap={8} pt={1}>
          <Skeleton variant="rect" height={25} width="60%" />
          <Skeleton variant="rect" height={35} />
        </Box>
        <Box mt={2}>
          <SearchLoader />
        </Box>
      </Box>
    ))}
  </>
);
